import { use } from "react"
import { AuthContext } from "@/utils"

export function useAuth() {
  const { auth } = use(AuthContext)!
  return auth || {}
}
